import {iContent, iSection} from "@/Engine/apiInterfaces";
import {Item} from "@/Engine/Item";
import {Vector3} from "three";
import {modelMeta} from "@/Constants/modelMeta";
import {$} from "@/Engine/state";
import {v3dMesh} from "@/Interfaces/common";
import {changeTextureCustom} from "@/Engine/changeTexture";

export class ShadowWall extends Item {
    name: string;

    constructor(
        props: iSection,
        width: number,
        positionX: number,
        hasTop: string,
        hasLegs: string,
        isOpen: string,
    ) {
        super(props);
        this.name = props.blender_name as string;
        const newAoName = 'wf_' + width*100 + '_' + 'c' + (hasLegs || hasTop?'_':'') + hasLegs + hasTop + '_AO' + '.jpg';
        const WfAoPath = 'AO/' + width*1000 + '/WF/' + newAoName;
        this.model.position.x += width/2 + positionX - 0.02;
        this.model.position.z = 1.13;
        console.log('wall: ' + WfAoPath);
        $.textureLoader.loadAsync(WfAoPath).then((texture)=>{
            changeTextureCustom(this._model.material, 'AO', texture)
        })

    }
}
